import { render } from "./PEvents.vue?vue&type=template&id=013f425b&scoped=true"
import script from "./PEvents.vue?vue&type=script&lang=js"
export * from "./PEvents.vue?vue&type=script&lang=js"

import "./PEvents.vue?vue&type=style&index=0&id=013f425b&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-013f425b"]])

export default __exports__